import PurchaseProvider from '../provider';
import PurchasesFilterSidebar from './filter';
import RecentTransactionTable from './recent';
import { Helmet } from 'react-helmet-async';
import Header from './header';
import SummaryData from './summary';

const Summary = () => {
  return (
    <PurchaseProvider>
      <>
        <Helmet>
          <title> Purchases </title>
        </Helmet>
        <Header />
        <SummaryData />
        <RecentTransactionTable />
        <PurchasesFilterSidebar />
      </>
    </PurchaseProvider>
  );
}

export default Summary;
